import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { WorkflowDemosService } from '../../services/workflow-demos.service';
import { WorkflowDemo } from '../../models/workflow-demo.model';
import { getYouTubeThumbnail } from '../../utils/youtube.utils';
import { PaginatedSectionBase } from '../shared/paginated-section.base';
import { SectionShellComponent } from '../shared/section-shell/section-shell.component';
import { DemoFilters, defaultDemoFilters } from '../../models/demo-filters.model';

@Component({
    selector: 'app-workflow-demos',
  imports: [TranslateModule, SectionShellComponent],
    templateUrl: './workflow-demos.component.html',
    styleUrl: './workflow-demos.component.scss'
})
export class WorkflowDemosComponent extends PaginatedSectionBase<WorkflowDemo> implements OnInit, OnChanges {
  @Input() selectedSolutions: string[] = [];
  @Input() filters: DemoFilters = defaultDemoFilters();
  @Input() bookmarkedIds: number[] = [];
  @Output() bookmarkToggle = new EventEmitter<number>();
  
  private allDemos: WorkflowDemo[] = [];

  constructor(private readonly workflowDemosService: WorkflowDemosService) {
    super();
  }

  ngOnInit(): void {
    this.workflowDemosService.getWorkflowDemos().subscribe({
      next: (demos) => {
        this.allDemos = demos;
        this.filterDemos();
      },
      error: (error) => {
        console.error('Error loading workflow demos:', error);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedSolutions'] || changes['filters']) {
      this.filterDemos();
    }
  }

  private filterDemos(): void {
    let demos = this.allDemos.slice();

    if (this.selectedSolutions.length) {
      demos = demos.filter(d => d.solutions?.some(s => this.selectedSolutions.includes(s)));
    }

    const { searchText, product, industry, discipline, material } = this.filters;
    const q = searchText.trim().toLowerCase();

    demos = demos.filter(d => {
      if (q && !d.name.toLowerCase().includes(q)) return false;
      if (product.length && !product.some(p => d.solutions?.includes(p))) return false;
      if (industry.length && !industry.some(i => d.industry?.includes(i))) return false;
      if (discipline.length && !discipline.some(dis => d.discipline?.includes(dis))) return false;
      if (material.length && !material.some(m => d.material?.includes(m))) return false;
      return true;
    });

    this.setFilteredItems(demos);
  }

  get visibleDemos(): WorkflowDemo[] {
    return this.visibleItems;
  }


  getThumbnail(demo: WorkflowDemo): string {
    return getYouTubeThumbnail(demo.videoUrl);
  }

  playVideo(demo: WorkflowDemo): void {
    window.open(demo.videoUrl, '_blank');
  }
}
